module.exports = __webpack_public_path__ + "static/media/DSCF0124-vQsoiYgs.bda62b13.JPG";